import { DateInputField } from "@hatch-digital-nl/abs-storybook/legacy";
import { ChangeEvent, InvalidEvent, JSX, useState } from "react";
import { useAssociatedFieldId } from "../utils/useAssociatedFieldId";

interface Props {
    label: string;
    onDateChange: (date: string) => void;
    date: string;
    errorMessage: string;
    max?: string;
    min?: string;
}

export const DateInputFieldComponent = (props: Props): JSX.Element => {
    const { date, onDateChange, label, errorMessage, max, min } = props;

    const [dateError, setDateError] = useState<string | null>();
    const { fieldId, fieldRef } = useAssociatedFieldId();

    return (
        <div className={"c-form__form-group"}>
            <label htmlFor={fieldId}>{label}</label>
            <div ref={fieldRef}>
                <DateInputField
                    required={true}
                    value={date}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                        setDateError(null);

                        onDateChange(event.target.value);
                    }}
                    onInvalid={(event: InvalidEvent<HTMLInputElement>) => {
                        event.preventDefault();

                        if (
                            (event.target as HTMLInputElement).validity
                                .valueMissing
                        ) {
                            setDateError(errorMessage);
                        }
                    }}
                    min={min}
                    max={max}
                />
            </div>
            {dateError && <p className={"c-error-message"}>{dateError}</p>}
        </div>
    );
};
